<template>
  <div
    class="itinerary-tab"
    v-bind:class="{ selectable: !selected }"
    data-count="2"
  >
    <div class="duration">
      <div class="start-end-time">{{ format(new Date(itinerary.startTime), 'H:mm') }} - {{ format(new Date(itinerary.endTime), 'H:mm') }}</div>
      <div class="duration-time">{{ itineraryDuration }}</div>
      <div class="skift">{{getAntalSkift(itinerary)}} skift</div>
      <!-- <div class="end-time">{{ format(new Date(itinerary.endTime), 'H:mm') }}</div> -->
    </div>
    <div class="modes">
      <ModeIcon
        v-for="mode in uniqueModes"
        :key="mode"
        :mode="mode"
      />
    </div>
    <div
      class="touchDown"
      @click="scrollDown"
    ></div>
  </div>
</template>

<script>
import { format } from 'date-fns';
import { getDurationString } from '@/util/itinerary';
import ModeIcon from '@/components/Icons/ModeIcon.vue';
export default {
  name: 'itinerary-tab',
  components: { ModeIcon },
  props: {
    itinerary: Object,
    selected: Boolean,
  },
  data: function() {
    return {
      format,
      getDurationString,
    };
  },
  methods: {
    scrollDown() {
      let element = document.getElementById('scrollto');
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    formatTime(time) {
      const date = new Date(time);
      return format(date, 'H:mm');
    },
    getAntalSkift(itinerary) {
      let antal = itinerary.legs.filter(
        i => i.mode === 'BUS' || i.mode === 'RAIL'
      ).length;
      return antal > 0 ? antal - 1 : antal;
    },
  },
  computed: {
    itineraryDuration: function() {
      if (!this.itinerary) {
        return undefined;
      }
      let { duration } = this.itinerary;
      return this.getDurationString(duration);
    },
    uniqueModes: function() {
      return [...new Set(this.itinerary.legs.map(leg => leg.mode))];
    },
  },
};
</script>

<style lang="scss" scoped>
.touchDown {
  display: none;
}

.itinerary-tab {
  height: 112px;
  background-color: #fff;
  border-radius: 6px 0 0 6px;
  margin-left: -10px;
  display: flex;
  transition: 0.3s;
  font-weight: 600;
  position: relative;
}

.itinerary-tab.selectable {
  padding-left: 10px;
  cursor: pointer;
  background-color: $primary-100;
  margin-left: 0;
}

.itinerary-tab.selectable:hover .duration > div {
  opacity: 1;
}

.itinerary-tab.selectable:hover .duration ~ .modes {
  opacity: 0.6;
}

.itinerary-tab:before {
  content: '';
  position: absolute;
  top: 40px;
  left: -48px;
  height: 33px;
  width: 33px;
  font-size: 14px;
  font-weight: bold;
  line-height: 10px;
  text-align: center;
  background: $primary-700;
  color: $primary-500;
  border: 8px solid $primary-100;
  border-radius: 50%;
}

.itinerary-tab.selectable:before {
  top: 42px;
  // content: attr(data-count);
  content: '';
  left: -50px;
  background: $primary-100;
  height: 26px;
  width: 26px;
}

.itinerary-tab.selectable:after {
  content: '';
  height: 1px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  background: #c6c9dd;
}

.duration {
  width: 120px;
  background-color: $primary-700;
  color: #fff;
  margin: 8px;
  border-radius: 6px;
  padding: 12px 13px;
}

.selectable .duration {
  background-color: #e4e6f0;
  color: $primary-700;
  margin-left: 0;
  padding: 12px 10px;
}

.duration > div {
  white-space: nowrap;
  padding: 4px 0;
}

.duration > div,
.duration ~ .modes {
  transition: opacity 0.3s ease;
}

.start-end-time,
.skift {
  opacity: 0.5;
  font-size: 14px;
  line-height: 14px;
}
.duration-time {
  flex-grow: 1;
  flex-basis: 0;
  font-weight: 700;
  font-size: 18px;
  line-height: 18px;
}
.selectable .duration-time {
  opacity: 0.7;
}

.selectable .start-end-time {
  opacity: 0.5;
}
.modes {
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 52px;
}
.selectable .modes {
  background-color: #fff;
  opacity: 0.4;
}

.mode-icon {
  padding: 1px;
}

@media only screen and (max-width: $mobile-max-width) {
  .itinerary-tab {
    margin-left: 0;
    margin-bottom: 20px;
    border-radius: 6px;
    height: 100px;
    justify-content: space-between;
    overflow: hidden;
    position: relative;
  }

  .itinerary-tab:before {
    display: none;
  }

  .modes {
    flex-basis: 20%;
  }

  .touchDown {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    flex-basis: 20%;
    border-left: 1px solid #d8d8d8;
    cursor: pointer;
  }

  .touchDown:after {
    content: '';
    margin-top: 8px;
    width: 8px;
    border: 8px solid transparent;
    border-top-color: $primary-700;
  }

  .selectable .touchDown {
    opacity: 0.2;
  }

  .itinerary-tab.selectable {
    padding-left: 0;
  }

  .selectable .duration {
    margin-left: 6px;
    padding: 12px 13px;
  }

  .duration {
    margin: 6px;
    width: auto;
    flex-basis: 55%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .duration-time {
    order: 1;
    flex-basis: 100%;
  }

  .start-end-time {
    order: 2;
  }

  .skift {
    order: 3;
  }
}
</style>
